export default "__VITE_ASSET__BIr6ZRuq__"